import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar, MatDialog } from '@angular/material';
import { OrdersService } from 'src/app/services/orders.service';

import * as moment from 'moment';

@Component({
  selector: 'app-dialog-add-order-payment',
  templateUrl: './dialog-add-order-payment.component.html',
  styleUrls: ['./dialog-add-order-payment.component.css']
})
export class DialogAddOrderPaymentComponent {

  isLoading: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ordersService: OrdersService, private snackBar: MatSnackBar, private dialog: MatDialog) { }

  onUpdatePayment(ID: string, form) {
    this.isLoading = true;

    const formData = new FormData();
    formData.append('_id', ID);
    formData.append('amount', form.amount);
    formData.append('date', moment(form.date).format('DD - MM - YYYY'));
    formData.append('transactionType', form.transactionType);

    this.ordersService.addPaymentAsAdmin(formData).subscribe(result => {
      this.ordersService.getAllOrdersAdAdmin(this.filter()).subscribe(result => {
        if (result.success) {
          this.isLoading = false;
          this.ordersService.setOrders(result.data);
          this.dialog.closeAll();
          this.snackBar.open('Payment updated', 'Dismiss', {
            duration: 3000
          });
        }
      })
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }

  filter() {
    return this.data.filter
  }
}
